import React from 'react';
import Hero from '../components/marketing/Hero';
import TrustStrip from '../components/marketing/TrustStrip';
import TrustedMarquee from '../components/marketing/TrustedMarquee';
import WorkflowSection from '../components/marketing/WorkflowSection';
import ImpactQuantified from '../components/marketing/ImpactQuantified';
import FeaturesSection from '../components/marketing/FeaturesSection';
import UseCasesSection from '../components/marketing/UseCasesSection';
import SecuritySection from '../components/marketing/SecuritySection';
import FinalCTA from '../components/marketing/FinalCTA';

export default function Landing() {
  return (
    <div data-testid="landing-page">
      <Hero />
      <TrustedMarquee />
      <TrustStrip />
      <WorkflowSection />
      <ImpactQuantified />
      <FeaturesSection />
      <UseCasesSection />
      <SecuritySection />
      <FinalCTA />
    </div>
  );
}
